import React from 'react';
import styled from 'styled-components';
import Select from 'react-select';

const Wrapper = styled.div`
  width: 100%;
  margin: 1em 1%;
  opacity: 1;

  @media (max-width: 768px) {
    padding: 0 2rem;
    box-sizing: border-box;

  }
`;

const Label = styled.label`
  font-size: 1rem;
  font-weight: bold;
  text-transform: uppercase;
`;


const Filter = ({ options, selectedOption, onChange, placeholder, title }) => {

  return (
    <Wrapper>
      <Label>{title}</Label>
      <Select
        key={`test-key`}
        value={selectedOption}
        onChange={onChange}
        isClearable={true}
        options={options||[]}
        placeholder={`${placeholder}`}
        styles={{
          container: (provided) => ({
            ...provided,
            marginTop: '1rem',
          })
        }}
      />
    </Wrapper>
  );
};

export default Filter;
